<gsp-base-footer-layout>
  <div class="footer-container pt-3" id="footerLayoutComponent">
    <div class="row col-xs-12 col-10">
      <div class="cd-lg-none copyright-sm col-sm-6">
        <a class="footer-nav" role="navigation">
          <div>
            {{ getMenuByOrder(1)?.Caption }}
          </div>
        </a>
      </div>
      <div class="col-sm-6 footer-text-right fieldBackground" title="language form" role="form">
        <a>{{ getMenuByOrder(2)?.Caption }} | </a>
        <form [formGroup]="languageFg" class="fg-display ">
          <div class="lng-width">
            <adp-select aria-hidden="true" [resourceData]="getResourceObject('Language', 'Select')" role="none"  title="Select Language" [listItems]="languages"
              formControlName="languageDropDown" class="fullWidth" (selectionChange)="onLanguageSelectorChange($event)">
            </adp-select>
          </div>
        </form>
      </div>
      <!-- gdpr footer content -->
      <!-- <div class="container border-dark border-top"> -->
      <div class="container footer-border border-top" role="banner">
        <div class="row">
          <div class="col-md-12 py-2 footer-content">
            <span>
              <adp-label labelKey="Global_Text_PostFooterContent"></adp-label>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</gsp-base-footer-layout>
